exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".perma_results{overflow-y:scroll;overflow-x:hidden;max-height:425px;position:relative;width:100%;z-index:3;background:#fff}.permLoader img{max-width:40px;margin:20px}.permLoader.savingOrderLoader{text-align:left;position:absolute;left:50px;top:15px}.prod_in_order .product_wrap .addto_amount{pointer-events:none}@media screen and (max-width:800px){.permLoader.savingOrderLoader{text-align:left;position:absolute;left:0;top:-20px}}", ""]);

// exports
